<template><div><h1 id="korrespondenzen-erfassen-aufbereiten" tabindex="-1"><a class="header-anchor" href="#korrespondenzen-erfassen-aufbereiten"><span>Korrespondenzen erfassen/aufbereiten</span></a></h1>
<p>Korrespondenz erfassen/aufbereiten — Erfassen und aufbereiten von Korrespondenzen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame können Korrespondenzen erfasst und aufbereitet werden.</p>
<p>Pfad: <code v-pre>Personen → Verarbeitungsläufe → Korrespondenzen aufbereiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobdatum</dt>
<dd>Datum des Jobs</dd>
<dt>Laufnummer</dt>
<dd>Laufnummer des Jobs (relevant wenn mehrere Jobs am gleichen Tag aufgegeben werden)</dd>
<dt>Status</dt>
<dd>Status der Aufbereitung. Die folgenden Status sind implementiert:
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>erfasst, noch nicht aufbereitet</td>
<td>Der Job ist erfasst, aber noch nicht aufbereitet.</td>
</tr>
<tr>
<td>aufbereitet, Daten noch nicht exportiert</td>
<td>Der Job ist erfasst und aufbereitet, aber die Daten wurden noch nicht exportiert.</td>
</tr>
<tr>
<td>aufbereitet und Daten exportiert</td>
<td>Der Job ist erfasst und aufbereitet und die Daten wurden exportiert.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Korrespondenztyp</dt>
<dd>Verarbeiteter <a class="link" href="ft.refdata.systblkortyp.html" title="Korrespondenztyp">Korrespondenztyp</a></dd>
<dt>Versanddatum</dt>
<dd>Versanddatum der Korrespondenz</dd>
<dt>Anzahl</dt>
<dd>Anzahl Datensätze, die aufbereitet wurden.</dd>
<dt>Drucker</dt>
<dd>Direkte Ausgabe auf <a class="link" href="ft.refdata.drucker.html" title="Drucker">Drucker</a></dd>
<dt>Ausgabedatei</dt>
<dd>Ausgabe in Steuerdatei zur Weiterverarbeitung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>Aufbereiten...</span></a></h3>
<p>Die Korrespondenzen werden nach der Erfassung automatisch aufbereitet. Mit dieser Funktion kann der Lauf gestartet/fortgesetzt werden, wenn der Job nicht gelaufen ist aufgrund z.b. von einem Unterbruch des Systems.</p>
<h3 id="dokumente-erstellen-drucken" tabindex="-1"><a class="header-anchor" href="#dokumente-erstellen-drucken"><span>Dokumente erstellen, drucken...</span></a></h3>
<p>Mit dieser Funktion können die aufbereiteten Daten in eine MS-Word-Steuerdatei exportiert werden, bzw. beim Einsatz von Document Output die Dokumente erstellt und gedruckt werden.</p>
<h3 id="protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#protokoll-drucken"><span>Protokoll drucken...</span></a></h3>
<p>Erstellt das Protokoll des Laufs.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/korrespondenz.html">Korrespondenz</RouteLink></p>
</div></template>


